/**
 * z-paging 组件全局配置
 * 参考文档: https://z-paging.zxlee.cn/
 */
import { getConfig } from '@/config/index'
export interface ZPagingConfig {
  /**
   * 空数据视图错误文本
   */
  'empty-view-error-text': string

  'empty-view-error-img': string

}

const zPagingConfig: ZPagingConfig = {
  /**
   * 空数据视图错误文本
   */
  'empty-view-error-text': '加载失败，点击重试',
  'empty-view-error-img': `${getConfig('staticUrl')}/ysz/client/error-image.png`,  
  
  
  
}

export default zPagingConfig